<template>
  <div class="table-th">
    <template v-if="header.id === 'checkbox'">
      <vchecklabel v-model="selectedAll" />
    </template>

    <template v-else-if="header.id === 'date'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('date')">{{ $tr('common.list.date') }}</span>

            <div class="column-filter-icon" @click.stop="set_show_filter('date_created')">
              <i
                class="icon icon-filter-edit"
                :class="filter.date_created && filter.date_created.length > 0 ? 'green' : 'grey'"
              ></i>
              <!-- <icon-filter :color="filter.date_created && filter.date_created.length > 0 ? 'green' : 'grey'" /> -->
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'date_created'"
                class="th_filter"
                type="date"
                :dates="filter_temp_dates"
                @input="set_filter_temp_dates"
                @apply="apply_filter('date_created')"
                @cancel="cancel_filter"
                @clear="date_clear"
              />
            </transition>
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'date',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('date')"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'vacancy'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('vacancy')">{{ $tr('common.list.vacancy') }}</span>

            <div
              v-if="filter_vacancies && filter_vacancies.length > 0"
              class="column-filter-icon"
              @click.stop="set_show_filter('vacancy')"
            >
              <i class="icon icon-filter-edit" :class="filter.vacancy_id.length > 0 ? 'green' : 'grey'"></i>
              <!-- <icon-filter :color="filter.vacancy_id.length > 0 ? 'green' : 'grey'" /> -->
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'vacancy'"
                class="th_filter"
                :list="filter_vacancies"
                :selected_list="filter_temp_selected_vacancy"
                @input="set_filter_temp_selected_vacancy"
                @apply="apply_filter('vacancy_id')"
                @cancel="cancel_filter"
                @clear="vacancy_id_clear"
              />
            </transition>
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'vacancy',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('vacancy')"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'name'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('name')">{{ $tr('common.list.name') }}</span>

            <div class="column-filter-icon" @click.stop="set_show_filter('name')">
              <i class="icon icon-filter-edit" :class="filter.name.length > 0 ? 'green' : 'grey'"></i>
              <!-- <icon-filter :color="filter.name.length > 0 ? 'green' : 'grey'" /> -->
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'name'"
                class="th_filter"
                type="text"
                :text_value="temp_name"
                @apply="apply_filter('name')"
                @input="set_temp_name"
                @clear="name_clear"
                @cancel="cancel_filter"
              />
            </transition>
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'name',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('name')"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'status'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('response_status')">{{ $tr('common.list.status') }}</span>

            <div
              v-if="filter_statuses && filter_statuses.length > 0"
              class="column-filter-icon"
              @click.stop="set_show_filter('status')"
            >
              <i class="icon icon-filter-edit" :class="filter.status_id.length > 0 ? 'green' : 'grey'"></i>
              <!-- <icon-filter :color="filter.status_id.length > 0 ? 'green' : 'grey'" /> -->
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'status'"
                class="th_filter"
                :list="filter_statuses"
                :selected_list="filter_temp_selected_statuses"
                @input="set_filter_temp_selected_statuses"
                @apply="apply_filter('status_id')"
                @cancel="cancel_filter"
                @clear="status_id_clear"
              />
            </transition>
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'response_status',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('response_status')"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'source'">
      <div class="column-filter column-filter--source">
        <div class="cell-flex pointer" @click="setSortingMethod('source')">
          {{ $tr('common.list.source') }}

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'source',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'email'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('email')">{{ $tr('common.list.email') }}</span>

            <div class="column-filter-icon" @click.stop="set_show_filter('email')">
              <i class="icon icon-filter-edit" :class="filter.email.length > 0 ? 'green' : 'grey'"></i>
              <!-- <icon-filter :color="filter.email.length > 0 ? 'green' : 'grey'" /> -->
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'email'"
                class="th_filter"
                type="text"
                :text_value="temp_email"
                @apply="apply_filter('email')"
                @input="set_temp_email"
                @clear="email_clear"
                @cancel="cancel_filter"
              />
            </transition>
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'email',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('email')"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'phone'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('phone')">{{ $tr('common.list.phone') }}</span>

            <div class="column-filter-icon" @click.stop="set_show_filter('phone')">
              <i class="icon icon-filter-edit" :class="filter.phone.length > 0 ? 'green' : 'grey'"></i>
              <!-- <icon-filter :color="filter.phone.length > 0 ? 'green' : 'grey'" /> -->
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'phone'"
                class="th_filter"
                type="phone"
                :text_value="temp_phone"
                @apply="apply_filter('phone')"
                @input="set_temp_phone"
                @clear="phone_clear"
                @cancel="cancel_filter"
              />
            </transition>
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'phone',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('phone')"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'creator'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('user_name')">{{ $tr('common.list.creator') }}</span>

            <div
              v-if="filter_creators && filter_creators.length > 0"
              class="column-filter-icon"
              @click.stop="set_show_filter('user_id')"
            >
              <i class="icon icon-filter-edit" :class="filter.user_id.length > 0 ? 'green' : 'grey'"></i>
              <!-- <icon-filter :color="filter.user_id.length > 0 ? 'green' : 'grey'" /> -->
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'user_id'"
                class="th_filter is-right"
                type="list"
                :list="filter_creators"
                :selected_list="filter_temp_selected_creators"
                :input_placeholder="$tr('common.list.vacancyCreator')"
                filter_name="user_id"
                @input="set_filter_temp_selected_creators"
                @apply="apply_filter('user_id')"
                @cancel="cancel_filter"
                @clear="creator_clear"
              />
            </transition>
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'user_name',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('user_name')"
          >
            <svg class="table-row-icon"><use xlink:href="/static/icons/table-icons.svg#sort" /></svg>

            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'tags'">
      <div class="column-filter">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span>{{ $tr('responses.tags.title') }}</span>
            <div class="column-filter-icon" @click.stop="set_show_filter('tag_id')">
              <i class="icon icon-filter-edit" :class="filter.tag_id.length > 0 ? 'green' : 'grey'"></i>
            </div>

            <transition name="slide-fade">
              <vtfilter
                v-if="show_filter === 'tag_id'"
                class="th_filter"
                type="list"
                :list="filter_tags"
                :selected_list="filter_temp_selected_tags"
                filter_name="tag_id"
                @input="set_filter_temp_selected_tags"
                @apply="apply_filter('tag_id')"
                @clear="tag_id_clear"
                @cancel="cancel_filter"
              />
            </transition>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      {{ header.name }}
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TableHead',

  props: [
    'headers',
    'header',
    'list',
    // 'isItSearch',
    'filter_temp_selected_vacancy',
    'filter_temp_selected_statuses',
    'filter_temp_dates',
    'filter_temp_selected_creators',
    'filter_temp_selected_tags',
    'temp_name',
    'temp_email',
    'temp_phone',
    'show_filter',
    // 'filter_loaded',
    'filter_creators',
    'filter_statuses',
    'filter_vacancies',
    'filter_tags'
  ],

  data() {
    return {
      isSelectedAllFilters: {}
    };
  },

  computed: {
    ...mapGetters({
      sorting: 'invites/sorting',
      filter: 'invites/filter',
      statuses: 'dictionary/responseStatuses'
    }),

    selectedAll: {
      get() {
        if (!this.list.length) return false;

        return this.list.every(invite => this.$store.getters['invites/isSelected'](invite));
      },

      set(val) {
        this.list.forEach(invite => this.$store.commit('invites/select', { model: invite, value: val }));
      }
    },

    sortingIcon() {
      return {
        'fa-caret-down': this.sorting.order === 'desc',
        'fa-caret-up': this.sorting.order === 'asc'
      };
    }
  },

  methods: {
    setSortingMethod(method) {
      const sorting = this.$store.getters['invites/sorting'];

      this.$store.dispatch('invites/updateSorting', {
        name: method,
        order: sorting.name !== method || sorting.order === 'desc' ? 'asc' : 'desc'
      });
    },

    set_temp_name(name) {
      this.$emit('set_temp_name', name);
    },

    set_temp_phone(phone) {
      this.$emit('set_temp_phone', phone);
    },

    set_temp_email(email) {
      this.$emit('set_temp_email', email);
    },

    set_filter_temp_dates(model) {
      this.$emit('set_filter_temp_dates', model.result);
    },

    set_filter_temp_selected_vacancy(model) {
      this.$emit('set_filter_temp_selected_vacancy', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    },

    set_filter_temp_selected_statuses(model) {
      this.$emit('set_filter_temp_selected_statuses', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    },

    set_filter_temp_selected_creators(model) {
      this.$emit('set_filter_temp_selected_creators', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    },

    set_filter_temp_selected_tags(model) {
      this.$emit('set_filter_temp_selected_tags', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    },

    apply_filter(filter) {
      if (this.isSelectedAllFilters[filter] && this[`${filter}_clear`]) {
        this[`${filter}_clear`]();
        return;
      }
      this.$emit('apply_filter', filter);
    },

    cancel_filter() {
      this.$emit('cancel_filter');
    },

    name_clear() {
      this.$emit('name_clear');
    },

    phone_clear() {
      this.$emit('phone_clear');
    },

    email_clear() {
      this.$emit('email_clear');
    },

    status_id_clear() {
      this.$emit('status_id_clear');
    },

    tag_id_clear() {
      this.$emit('tag_id_clear');
    },

    date_clear() {
      this.$emit('date_clear');
    },

    vacancy_id_clear() {
      this.$emit('vacancy_id_clear');
    },

    creator_clear() {
      this.$emit('creator_clear');
    },

    set_show_filter(v) {
      this.$emit('set_show_filter', v);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  font-size: 17px;
}

.green {
  color: $green;
}

.grey {
  color: $grey-darker;
}

.column-filter {
  display: flex;
  align-items: center;
}

.column-filter-icon {
  margin-left: 6px;
  display: flex;
  align-items: center;
}
</style>
